import { IUserMilestone } from '../../IUserMilestone';

/**
 * Retailer has seen the update business info modal
 */
export const UPDATE_BUSINESS_INFO_MODAL_SEEN =
  'UPDATE_BUSINESS_INFO_MODAL_SEEN' as IUserMilestone.RetailerMilestone;
